<script>
/**
 * Login component
 */
export default {
    data() {
        return {
        email: "",
        password: "",
        tryingToLogIn: false,
        isAuthError: false
        };
    },
    props: {
        submitUrl: {
        type: String,
        required: true
        },
        authError: {
        type: String,
        required: false,
        default: () => null
        }
    },
    mounted() {
        this.isAuthError = !!this.authError;
    }
};
</script>

<template>
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
            <h2 class="text-center text-primary">Plataforma Evaluación Red Inmaculada Concepción</h2>
            <div class="card overflow-hidden">
                <div class="bg-soft-primary">
                    <div class="row p-3">
                        <div class="col-4 text-center">
                            <img src="/images/imagenes/logo.png" alt height="100" />
                        </div>
                        <div class="col-8">
                            <div class="text-primary">
                                <h4 class="text-primary">¡Bienvenido al Portal !</h4>
                                <p>Inicie sesión para continuar.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>
                    <b-form class="p-2" :action="submitUrl" method="POST">
                        <slot />
                        <b-form-group id="input-group-1" label="Correo Electrónico" label-for="input-1">
                            <b-form-input id="input-1" name="email" v-model="email" type="text" placeholder="Ingresar Correo"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-2" label="Contraseña" label-for="input-2">
                            <b-form-input
                                id="input-2"
                                v-model="password" name="password"
                                type="password"
                                placeholder="Ingresar Contraseña"
                            ></b-form-input>
                        </b-form-group>
                        <div class="custom-control custom-checkbox">
                            <input id="customControlInline" type="checkbox" class="custom-control-input" />
                            <label class="custom-control-label" for="customControlInline">Recuerdarme</label>
                        </div>
                        <div class="mt-3">
                            <b-button type="submit" variant="primary" class="btn-block">Ingresar</b-button>
                        </div>
                        <div class="mt-4 text-center">
                            <a href="/password/reset" class="text-muted">
                                <i class="mdi mdi-lock mr-1"></i> Obtener contraseña
                            </a>
                        </div>
                    </b-form>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
            <div class="mt-5 text-center">
                <p>
                    © {{new Date().getFullYear()}} Red IC
                </p>
            </div>
            <!-- end row -->
        </div>
        <!-- end col -->
    </div>
    <!-- end row -->
</template>

